<template>
	<div class="shop-product-check">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Shop Check Products</h1>
		<div class="content-wrapper">
			<div class="radioCheck">
				<b-radio v-model="checkItem" name="name" native-value="count">
					Count Only
				</b-radio>
				<b-radio v-model="checkItem" name="name" native-value="check">
					Check products only
				</b-radio>
				<b-radio v-model="checkItem" name="name" native-value="import">
					Import missing products
				</b-radio>
			</div>

			<b-field label="Select Shop (required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="button-container" @click="verifyContent()">
				<div class="big-button">
					Check Products
				</div>
			</div>

			<div class="progress" v-if="fetchingProducts == true">Fetching {{ totalCount }} products</div>

			<div class="progress" v-if="totalCount > 0">Total products in system {{ totalCount }}</div>
			<div class="progress" v-if="totalShopProductCount > 0">Total products in this shop {{ totalShopProductCount }}</div>
			<div class="progress" v-if="processCount > 0">Processing {{ processCount }} of {{ totalCount }}</div>
			<div class="progress" v-if="missingCount > 0">Missing {{ missingCount }} of {{ totalCount }}</div>
			<div class="progress" v-if="addedCount > 0">Added new {{ addedCount }} records</div>

			<div class="check-results">
				<div v-if="missingProducts.length > 0">
					<h1>MISSING PRODUCTS</h1>
					<div v-for="(bd_code, key) of missingProducts" :key="key">
						<p>{{ bd_code }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		isLoading: false,
		limit: 100,
		missingProducts: [], // Missing product records
		shops: [],
		shopsSuggestions: '',
		selectedShop: null,
		totalShopProductCount: 0, // Total products in selected shop
		fetchingProducts: false,
		processCount: 0,
		totalCount: 0,
		missingCount: 0,
		addedCount: 0,
		extraRecord: [],
		checkItem: 'count'
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getShops()
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Verify if the brand ID and values are valid
		verifyContent: async function() {
			if (this.selectedShop == null || !this.selectedShop._id) {
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Please select a shop!'
				})
			}

			this.totalCount = 0
			this.processCount = 0
			this.totalCount = 0
			this.missingCount = 0
			this.addedCount = 0
			this.totalShopProductCount = 0

			this.isLoading = true

			const compo = this

			var data = {
				limit: 1
			}

			const apiExportProducts = await this.$api.getProducts({ data })

			this.totalCount = apiExportProducts.data.total

			if (this.checkItem == 'count') {
				this.getTotalShopProduct()

				this.isLoading = false
				return
			}

			this.fetchingProducts = true

			this.totalLoop = Math.ceil(apiExportProducts.data.total / this.limit)

			if (apiExportProducts !== undefined && apiExportProducts.data.total > 0) {
				this.totalCount = apiExportProducts.data.total
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}

			var i
			var skip
			const parallel = []

			for (i = 0; i < this.totalLoop; i++) {
				// for (i = 0; i < 1; i++) {
				skip = i * this.limit
				data = {
					limit: this.limit,
					// sort: {
					// 	createdAt: 'desc'
					// },
					skip
				}

				var result = this.getProductsLoop(data)
				parallel.push(result)
			}

			const total_result = await Promise.all(parallel)

			const total_products = []

			total_result.map(result => {
				const { list } = result.data

				list.map(product => {
					total_products.push(product)
				})
			})

			total_products.sort((a, b) => {
				const aTime = compo
					.$moment(a.createdAt)
					.toDate()
					.getTime()
				const bTime = compo
					.$moment(b.createdAt)
					.toDate()
					.getTime()

				return aTime - bTime
			})

			if (this.checkItem == 'check') {
				this.checkProducts(total_products)
			} else if (this.checkItem == 'import') {
				this.importProducts(total_products)
			}

			this.fetchingProducts = false
		},

		// This function will check missing products
		checkProducts: async function(total_products) {
			this.getTotalShopProduct()

			for (const p of total_products) {
				if (p.bd_code) {
					let bd_code = p.bd_code

					let data = {
						shop: this.selectedShop._id,
						refs: {
							product: {
								bd_code
							}
						}
					}

					try {
						const shopProduct = await this.$api.shopProduct({ data })

						if (shopProduct === undefined || shopProduct.data.count == 0) {
							this.missingProducts.push(bd_code)
							this.missingCount++
						}
					} catch (error) {
						this.extraRecord.push(bd_code)
					}
				}

				this.processCount++
			}

			this.isLoading = false
		},

		getTotalShopProduct: async function() {
			let data = {
				shop: this.selectedShop._id
			}

			const totalShopProduct = await this.$api.shopProduct({ data })

			if (totalShopProduct !== undefined) {
				this.totalShopProductCount = totalShopProduct.data.total
			}
		},

		importProducts: async function(total_products) {
			for (const p of total_products) {
				if (p.bd_code) {
					let bd_code = p.bd_code

					let data = {
						shop: this.selectedShop._id,
						product: p._id,
						stock: '0',
						status: true
					}

					try {
						const shopProduct = await this.$api.addShopProduct({ data })

						if (shopProduct !== undefined) {
							this.addedCount++
						}
					} catch (error) {
						this.extraRecord.push(bd_code)
					}
				}

				this.processCount++
			}

			this.isLoading = false
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		getProductsLoop: async function(data) {
			return await this.$api.getProducts({ data })
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
